import memberManagementEvents from "@/modules/member-management/events/events"
import memberManagementEventHandlers from "@/modules/member-management/events/event-handlers"
import { EventRegister } from "@common/events/event-register"

export const registerEventListeners: EventRegister = (eventBus) => {
  eventBus.$on(
    memberManagementEvents.COMPANY_MEMBERS_CHANGED,
    memberManagementEventHandlers.handleCompanyMembersChangedEvent
  )
  eventBus.$on(
    memberManagementEvents.NO_CENSUS_CHANGE_INDICATED,
    memberManagementEventHandlers.handleNoCensusChangeIndicatedEvent
  )
  eventBus.$on(memberManagementEvents.CENSUS_UPLOADED, memberManagementEventHandlers.handleCensusUploadedEvent)
}
